<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-image-editing`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31 21a7.003 7.003 0 006.71-5h5.008c.446 0 .607-.046.77-.134a.908.908 0 00.378-.378c.088-.162.134-.324.134-.77v-1.436c0-.446-.046-.607-.134-.77a.908.908 0 00-.378-.378c-.163-.088-.324-.134-.77-.134l-5.008-.001a7.003 7.003 0 00-13.42 0L5.282 12c-.446 0-.607.046-.77.134a.908.908 0 00-.378.378c-.088.162-.134.324-.134.77v1.436c0 .446.046.607.134.77a.906.906 0 00.378.378c.163.088.324.134.77.134H24.29c.86 2.892 3.539 5 6.71 5zm0-4a3 3 0 110-6 3 3 0 010 6zM17 41a7.003 7.003 0 006.71-5h19.008c.446 0 .607-.046.77-.134a.908.908 0 00.378-.378c.088-.163.134-.324.134-.77v-1.436c0-.446-.046-.607-.134-.77a.908.908 0 00-.378-.378c-.163-.088-.324-.134-.77-.134l-19.008-.001a7.003 7.003 0 00-13.42 0L5.282 32c-.446 0-.607.046-.77.134a.908.908 0 00-.378.378c-.088.163-.134.324-.134.77v1.436c0 .446.046.607.134.77a.906.906 0 00.378.378c.163.088.324.134.77.134h5.008c.86 2.892 3.539 5 6.71 5zm0-4a3 3 0 110-6 3 3 0 010 6z"/></svg>
</template>
<script>

export default {
  name: 'IconImageEditing',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
